import {SandboxTree, User} from 'yougile-model'
import {TableUserInfo} from '@components/common/users-table/users-table'
import {UsersTableUtil} from '@components/common/users-table/users-table-util'

export interface MentionUserInfo extends TableUserInfo {
  id: string
  name: string
}

// todo: maybe this is not needed
export type MentionModelData = Pick<MentionUserInfo, 'userId'>

export const userToMentionUserInfo = (
  box: SandboxTree,
  user: User
): MentionUserInfo => {
  const x = UsersTableUtil.convertUser(box, user)
  return {...x, id: '@' + x.userName.trim(), name: x.userName.trim()}
}

export const highlightFromVariants = (
  s: string,
  vars: string[] | undefined
): string => vars?.filter(v => s.toLocaleLowerCase().includes(v))?.[0] ?? ''
